import { mapGetters } from "vuex";

import branchUser from "./pages/branchUser.js";
import branchHOD from "./pages/branchHOD.js";
import procurement from "./pages/procurement.js";
import md from "./pages/md.js";


export const dbSettingsMixin = {
    data: function () {
        return {
            dasboard: [
                {
                    subject: "branchUser",
                    endPoint: "branchUserDashboard",
                    filter: {
                        userId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
                    },
                    data:branchUser
                }, 
                {
                    subject: "branchHOD",
                    endPoint: "branchHODDashboard",
                    filter: {
                        branchId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
                    },
                    data:branchHOD
                }, 
                {
                    subject: "vendor",
                    endPoint: "branchHODDashboard",
                    filter: {
                        branchId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
                    },
                    data:branchHOD
                }, 
                {
                    subject: "procurement",
                    endPoint: "procurementDashboard", 
                    filter: {},
                    data:procurement
                }, 
                {
                    subject: "md",
                    endPoint: "MDDashboard", 
                    filter: {
                        branchId: ""  //WE SET THIS ON FLY WHEN THE COMPONENT IS CALLED
                    },
                    data:md
                }, 

            ],
        }
    },
    methods: {

        getDashboard(subject) {
            var search = this.dasboard.filter(f =>
                f.subject == subject
            );

            if (search[0].filter.hasOwnProperty("userId")) {
                search[0].filter.userId = this.getUserInfo.id;
            }

            if (search[0].filter.hasOwnProperty("branchId")) {
                search[0].filter.branchId = this.getUserInfo.branch;
            }
            //loop through the data and update the filter id 
            return search[0];
        }


    },
    computed: {
        ...mapGetters({
            getUserInfo: "auth/getUserInfo",
        }),

    },
    created() {
    }
};